import React from 'react';
import PropTypes from 'prop-types';

/**
 * Preload Decks sidebar module - load sample decks
 */
function PreloadDecks({
  isCollapsed,
  onToggle,
  preloadDecks,
  onLoadDeck,
}) {
  return (
    <div className="sidebar-section preload-decks-section">
      <div className="section-header">
        <h4>📦 Sample Decks</h4>
        <button 
          className="collapse-btn" 
          onClick={onToggle}
          title={isCollapsed ? "Expand" : "Collapse"}
        >
          {isCollapsed ? '▶' : '▼'}
        </button>
      </div>

      {!isCollapsed && (
        <div className="preload-decks-list">
          {preloadDecks.length === 0 ? (
            <p className="no-decks-message">No sample decks available yet.</p>
          ) : (
            preloadDecks.map((deck) => (
              <div key={deck.id} className="preload-deck-item">
                <div className="preload-deck-image">
                  {deck.imageUrl ? (
                    <img src={deck.imageUrl} alt={deck.name} />
                  ) : (
                    <div className="placeholder-image">🃏</div>
                  )}
                </div>
                <div className="preload-deck-info">
                  <strong>{deck.name}</strong>
                  <p className="preload-deck-description">{deck.description}</p>
                  <button 
                    className="load-deck-btn"
                    onClick={() => onLoadDeck(deck)}
                    disabled={!deck.deckCode}
                  >
                    {deck.deckCode ? 'Load Deck' : 'Coming Soon'}
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}

PreloadDecks.propTypes = {
  isCollapsed: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  preloadDecks: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      description: PropTypes.string,
      imageUrl: PropTypes.string,
      deckCode: PropTypes.string,
    })
  ).isRequired,
  onLoadDeck: PropTypes.func.isRequired,
};

export default PreloadDecks;
